import moment from "moment";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import FileNameCell from "~/pages/components/cell_types/FileNameCell.vue";
import DateFormatEnum from "../../../../enums/DateFormatEnum";
import PublicStateCell from "~/pages/components/cell_types/PublicStateCell.vue";

const state = {
  attachableCategories: [],
  loadingCategories: false,
  attachables: {},
  showUploadModal: false,
  activeAttachableCategoryName: null,
  canPublishDocuments: false,
  hasAttachableType: false,
  hasAttachableId: false,
  isInstance: false,
  category: null,
  noteCount: 0,
  customerId: null,
  tableRows: [],
  loaded: false,
  paginations: {},
  page: 1,
  perPage: 15,
  orderBy: "created_at",
  order: "desc",
  selectedAttachables: {},
  showMoveModal: false,
  showCopyModal: false,
  showDeleteModal: false,
  editingAttachableWithId: null,
  activeCategoryId: null,
  tableHeaders: [
    {
      key: (row) => row.child_instance?.data,
      title: "Naam",
      typeComponent: FileNameCell,
    },
    {
      key: (row) => moment(row.child_instance?.data.date).format(DateFormatEnum.DISPLAY_DATE),
      title: "Aangemaakt op",
      width: "150px",
    },
    {
      key: (row) => {
        const bytes = row.child_instance?.data.size;
        /**
         * https://stackoverflow.com/a/28120564/11908727
         */
        if (bytes === 0) { return "0.00 B"; }
        const e = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / 1024 ** e).toFixed(2)} ${" KMGTP".charAt(e)}B`;
      },
      title: "Grootte",
      width: "150px",
    },
    {
      typeComponent: PublicStateCell,
      title: "Publiek",
      width: "150px",
    },
  ],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
